/**
 * CatchupChannel entity class
 */

/**
 * CatchupChannelFactory
 * returns CatchupChannel entity class
 *
 * @class CatchupChannelFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.CatchupChannel} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CatchupChannelFactory
 */
/* @ngInject */
export default function CatchupChannelFactory (Catchup) {
  /* === CatchupChannel class === */

  /**
   * CatchupChannel model
   *
   * @class CatchupChannel
   * @classdesc CatchupChannel model
   * @memberof models
   * @see models
   * @extends models.ChannelDTO
   * @param {Object} [object] - initial object, containing CatchupChannel entity fields
   * @return {models.CatchupChannel} CatchupChannel entity
   */
  function CatchupChannel () {
    var obj = Catchup.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  CatchupChannel.prototype = Object.create(Catchup.prototype)
  CatchupChannel.prototype.constructor = CatchupChannel

  /* === CatchupChannel instance methods & fields === */

  Object.assign(CatchupChannel.prototype, {

    /**
     * url template
     *
     * @memberof models.CatchupChannel#
     * @type {String}
     */
    _urlTemplate: 'api/channels/{{::channel.id}}/services/catchups/{{::id}}',

    /**
     * public url template,
     *
     * @memberof models.CatchupChannel#
     * @type {String}
     */
    _publicUrlTemplate: 'channels/{{::channel.id}}/services/catchups/{{::id}}'

  })

  /* === CatchupChannel static methods & fields === */

  // copy all static methods from ChannelDTO class
  Object.assign(CatchupChannel, Catchup)
  CatchupChannel._name = 'CatchupChannel'
  CatchupChannel._publicName = 'Catchup Channel'
  CatchupChannel.init()

  return CatchupChannel
}
